'use client';

import { useContext } from 'react';
import { getAppConfig } from '@bts-web/core-app-config';
import { AppLogo } from '../AppLogo/AppLogo.use-client';
import { UserInfoContext } from '../../../../common/userinfo/UserInfoContext/UserInfoContext';
import { DEFAULT_LOGO_SIZE } from '../../../constants';

const { appLogoSize } = getAppConfig();

const AppLogoWithIslamicProp = ({
  size = appLogoSize || DEFAULT_LOGO_SIZE,
  textLogoSize,
  color,
  noText,
  variant,
}: {
  size?: number;
  textLogoSize?: number;
  color?: string;
  noText?: boolean;
  variant?: 'default' | 'inverted';
}) => {
  const { isIslamicUser } = useContext(UserInfoContext).data ?? {};

  return (
    <AppLogo
      size={size}
      textLogoSize={textLogoSize}
      color={color}
      isIslamicUser={isIslamicUser}
      noText={noText}
      variant={variant}
    />
  );
};

export { AppLogoWithIslamicProp };
